import { render, staticRenderFns } from "./DesignBasis.vue?vue&type=template&id=1c37eb72"
import script from "./DesignBasis.vue?vue&type=script&lang=js"
export * from "./DesignBasis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports